import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ViewContainerRef,
  Renderer2,
  ElementRef,
  ApplicationRef,
  HostListener
} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {provideParent} from 'projects/core/src/public-api';
import {ProjectHolder} from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {TrelloChecklist} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-checklist';
import {environment} from 'projects/mobile/src/environments/environment';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ProjectAlert} from 'projects/app-misc/src/app/modules/alert/data/alert';
import {
  ProjectActivityDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/project-activity-dialog/project-activity-dialog.component';
import {ProjectsQuery} from 'projects/app-misc/src/app/modules/project-misc/data/project/projects.query';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {ProjectWindowQuery} from 'projects/app-misc/src/app/modules/project-misc/state/project-window.query';
import {ProjectWindowStore} from 'projects/app-misc/src/app/modules/project-misc/state/project-window.store';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import {merge, forkJoin, Subject} from 'rxjs';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConfirmationService} from 'primeng/api';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {SimpleSnackBar, MatSnackBarRef, MatSnackBar} from '@angular/material/snack-bar';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {User} from 'projects/core/src/lib/login/data/user';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {ContactInfo} from '../../../../../../../app-misc/src/app/modules/customer/data/contactInfo';

@Component({
  selector: 'app-project-info',
  templateUrl: './project-info.component.html',
  styleUrls: ['./project-info.component.scss'],
  providers: [
    provideParent(ProjectHolder, ProjectInfoComponent),
    ProjectWindowQuery,
    ProjectWindowStore,
    DeviceDetectorService,
    ConfirmationService]
})
@RxJSUnsubscribe
export class ProjectInfoComponent implements OnInit, ProjectHolder, OnDestroy, RxJSUnsubscribable {

  project: Project;
  projectAlert: ProjectAlert[];

  projectNumber: number;

  prodCheckListName = environment.trelloProdCheckListName;

  checkLists: TrelloChecklist[] = [];

  projectActivitiesIsLoading = true;
  punchCheckListIsLoading = true;


  mapLocation: string;

  editItem: number;

  apiUrl = environment.apiUrl;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  showCvTooltip = false;
  showOptions = false;

  isMobile: boolean;

  currentUser: User;

  nfsContactTemplate: ContactInfo = {
    id: -1,
    name: 'No Selected Contact'
  }

  constructor(
    private snackBar: MatSnackBar,
    private projectService: ProjectService,
    protected projectsQuery: ProjectsQuery,
    protected appStateQuery: AppStateQuery,
    protected projectWindowQuery: ProjectWindowQuery,
    protected projectWindowStore: ProjectWindowStore,
    protected elementRef: ElementRef,
    protected appRef: ApplicationRef,
    private trelloService: TrelloService,
    private projectActivityService: ProjectActivityService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectWindowComponent>,
    protected deviceDetectorService: DeviceDetectorService,
    protected viewContainerRef: ViewContainerRef,
    protected confirmationService: ConfirmationService,
    protected renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) private data: {
      projectNumber: number,
      projectCode?: string,
      notification?: Notification
    }
  ) {
    this.projectNumber = data.projectNumber;

    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user;
    })
  }

  ngOnInit() {

    document.addEventListener('keydown', event => {
      const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+
      if (key === 'Escape') {
        this.dialogRef.close();
      }
    });

    this.isMobile = this.deviceDetectorService.isMobile();

    if (this.isMobile) {
      this.fullScreen();
    }


    let getProjectService = this.projectService.getProject(this.projectNumber)

    if (this.data.projectCode) {
      getProjectService = this.projectService.getProjectByNumber(this.data.projectCode)
    }

    getProjectService.subscribe(project => {
      this.project = project

      if (this.project.location) {
        this.mapLocation = this.project.location
      }

      this.projectService.getProjectAlerts(this.projectNumber).subscribe(projectAlerts => {
        this.projectAlert = projectAlerts
      })


      if (this.project.card.checklists === null || typeof this.project.card.checklists === 'undefined') {
        this.punchCheckListIsLoading = true;

        forkJoin([this.trelloService
          .getGroupedPunchList(this.project.id), this.trelloService.getChecklists(this.project.id)])
          .subscribe(result => {
            const punchlist = result[0] as TrelloChecklist;
            const checklistsArr = result[1] as TrelloChecklist[];

            if (punchlist) {
              this.project.card.checklists = [punchlist].concat(checklistsArr)
            } else {
              this.project.card.checklists = checklistsArr
            }


            this.findPunchChecklist();
          })
      } else {
        this.findPunchChecklist();
      }

      this.trelloService.saveCheckItems$
        .pipe(
          takeUntil(this.getUnsubFromAllSubs())
        )
        .subscribe(() => {
          this.findPunchChecklist()
        })

      this.getProjectActivities();

      merge(
        this.projectActivityService
          .projectActivityEmitter
          .add
          .pipe(filter(event => event.entity.project.id === this.project.id))
          .pipe(
              tap(event => {
                    if (this.project.activities && !this.project.activities.find(act => act.id === event.entity.id)) {
                      this.project.activities.push(event.entity);
                    }
                  }
              )
          ),

        this.projectActivityService
          .projectActivityEmitter
          .update
          .pipe(filter(event => event.entity.project.id === this.project.id))
          .pipe(
              tap(event => {
                    if (this.project.activities) {
                      const index = this.project.activities.findIndex(pa => pa.id === event.entityId);
                      if (index >= 0) {
                        this.project.activities[index] = event.entity;
                      } else {
                        this.project.activities.push(event.entity);
                      }
                    }
                  }
              )),

        this.projectActivityService
          .projectActivityEmitter
          .remove
          .pipe(filter(event => this.project.activities.findIndex(pa => pa.id === event.entityId) >= 0))
          .pipe(
              tap(event => {
                    this.project.activities = this.project.activities.filter(pa => pa.id !== event.entityId)
                  }
              )
          )
      )
        .pipe(
          takeUntil(this.getUnsubFromAllSubs()),
          debounceTime(250),
          distinctUntilChanged()
        )
        .subscribe(() => {
          this.updateActivities();
        })
    }, error => {
      if (this.activeSnackBar) {
        this.activeSnackBar.dismiss();
      }

      this.activeSnackBar = this.snackBar.open(error.message, '', {
        duration: 5000,
        panelClass: 'error-project-snackbar',
        verticalPosition: 'top',
      });

      this.dialogRef.close();
    })

  }

  ngOnDestroy() {

  }

  fullScreen() {
    (this.elementRef.nativeElement as HTMLElement).parentElement.parentElement.classList.add('FULLSCREEN-DIALOG')
  }

  findPunchChecklist() {
    let punchList: TrelloChecklist;
    this.project.card.checklists.forEach(checkList => {
      if (this.prodCheckListName !== checkList.name) {
        this.checkLists.sort()

        // checkList.checkItems.sort((x, y) => {
        // 	return (!x.ready === !y.ready) ? 0 : x ? -1 : 1;
        // });

        this.checkLists.push(checkList)
      }
    });

    punchList = this.project.card.checklists.find(list => list.name === environment.trelloPunchCheckListName)

    if (punchList && punchList.checkItems) {
      punchList.checkItems.forEach(item => {
        if (item.tags) {
          item.tags.sort((taga, tagb) => taga.type.pos - tagb.type.pos)
        }
      })
    }


    this.punchCheckListIsLoading = false;
  }

  getProjectActivities() {
    this.projectActivitiesIsLoading = true;
    this.projectActivityService.getProjectActivities(this.project.id).subscribe(projectActivities => {
      this.project.activities = projectActivities
      this.projectActivitiesIsLoading = false;
    })

  }

  updateActivities() {
    this.projectActivityService.getProjectActivities(this.project.id).subscribe(projectActivities => {
      this.project.activities = projectActivities
    })

  }

  openProjectActivityWindow(): void {
    this.projectActivityService.getActivityTypes().subscribe(types => {

      const dialogRef = this.dialog.open(ProjectActivityDialogComponent, {
        data: {project: this.project, buttonLabel: 'Add', types},
        panelClass: 'project-activity-dialog',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(() => {
        this.updateActivities();
      });

    })
  }

  openSnackBar(message: string, duration = 5000) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'file-error-snackbar',
      verticalPosition: 'top',
    });
  }

  deleteAllActivities() {
    this.confirmationService.confirm({
      key: 'delete',
      header: 'Delete activities?',
      message: `Delete All Activities?`,
      accept: () => {
        this.projectActivityService.deleteActivities(this.project.id)
          .subscribe(ids => {
              this.project.jobDeliveryDate = null;
              this.project.punchListDueDate = null;
              this.project.clientPickupDate = null;
              this.project.dueDate = null;
              this.project.finishDate = null;
              console.log('Activities deleted for project: ', this.project.id);
                (ids as number[])?.forEach(projectActivityId => {
                  if (projectActivityId) {
                    console.log('activities deleted, id: ', projectActivityId);
                    this.project.activities = this.project.activities.filter(pa => pa.id !== projectActivityId)
                  }
                })

              this.getProjectActivities()
            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                if (error.type === 'project.ProjectException') {
                  this.openSnackBar(error.message)
                }
              }
            })
      }
    });
  }

  recalculateAllActivities() {
    this.confirmationService.confirm({
      key: 'recalculate',
      header: 'Recalculate activities?',
      message: `Recalculate All Activities?`,
      accept: () => {
        this.projectActivityService.recalculateActivities(this.project.id)
          .subscribe(activities => {
            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                if (error.type === 'project.ProjectException') {
                  this.openSnackBar(error.message)
                }
              }
            })
      }
    });
  }

  openLastDrawing(): void {
    // this.sendData.emit(this.currentUser)
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/files/last-drawing',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
    })
  }

  openProposal(): void {
    // this.sendData.emit(this.currentUser)
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/files/last-proposal',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
    })
  }

  toggleCvTooltip(event: Event) {
    event.stopPropagation();
    this.showCvTooltip = !this.showCvTooltip;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const cvBlock = target.closest('.cv-sync-block');
    if (!cvBlock && this.showCvTooltip) {
      this.showCvTooltip = false;
    }
  }

  toggleOptions() {
    this.showOptions = !this.showOptions;
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
